import { getApiUrl } from "../../lib/api";

export default function AuthBar({ user, setUser }) {
  if (!user) return null;

  const logout = async () => {
    try {
      await fetch(getApiUrl("/api/auth/logout"), {
        method: "POST",
        credentials: "include",
      });
    } catch (e) {
      console.warn("Logout failed:", e);
    }
    setUser(null);
    window.location.href = "/";
  };

  return (
    <header className="bg-black border-b border-gray-800 text-white px-4 py-3 flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <a href="/">
          <img
            src="/DropGroove-Logo.png"
            alt="Drop Groove Logo"
            className="w-32 h-auto drop-shadow-lg"
          />
        </a>
        <nav className="space-x-6 text-lg font-medium">
          <a href="/" className="hover:text-red-400">
            Single Listing
          </a>
          <a href="/batch" className="hover:text-red-400">
            Batch Mode
          </a>
        </nav>
      </div>

      <div className="flex items-center space-x-4 text-sm">
        <div className="flex items-center space-x-2">
          <img
            src={user.picture}
            alt={user.name}
            className="w-8 h-8 rounded-full border border-gray-600"
          />
          <div className="flex flex-col">
            <span className="font-semibold">{user.name}</span>
            <span className="text-gray-400 text-xs">{user.email}</span>
          </div>
        </div>
        <button
          onClick={logout}
          className="text-red-400 hover:text-red-500 underline"
        >
          Logout
        </button>
      </div>
    </header>
  );
}
